import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import svgChevron from '@img/icons/background/chevron-down.svg?url';
import styled, { css } from 'styled-components';
export const CommonSelectStyles = css `
  ${fonts.daxWide.regular};

  /* Ensure iOS doesn't apply default border radius */
  -webkit-appearance: none !important;
  display: block;
  background: var(--bgColour);
  border: 1px solid var(--borderColour);
  border-radius: var(--borderRadius);
  color: var(--textColor);
  height: 50px;
  font-size: ${fluid(16, 18)};
  margin: 0;
  padding: 7px 12px;
  width: 100%;

  &:disabled {
    opacity: 0.5;
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-width: 2px;
    outline-style: solid;
  }

  --bgColour: ${brand.global.white};
  --borderColour: ${brand.ess.secondary.midGrey};

  [data-site='ess'] & {
    --borderRadius: 4px;
    --textColor: ${brand.ess.secondary.darkGrey};
  }

  [data-site='mep'] & {
    --borderRadius: 8px;
    --textColor: ${brand.mep.secondary.darkestGrey};
  }
`;
export const CommonDropdownWrapperStyles = css `
  position: relative;

  &::after {
    content: '';
    display: inline-flex;
    align-items: center;
    width: 14px;
    height: 8px;
    position: absolute;
    top: 50%;
    right: 20px;
    background-color: ${brand.global.white};
    background-image: url(${svgChevron});
    transform: translateY(-50%);
    pointer-events: none;
  }
`;
const Wrapper = styled.div `
  ${CommonDropdownWrapperStyles};
`;
const Select = styled.select `
  ${CommonSelectStyles};
`;
const SelectStyles = {
    Wrapper,
    Select,
};
export default SelectStyles;
